module.exports = __webpack_public_path__ + "img/1435448274.19295687.jpg";